import React from 'react';

const CheckIcon = ({ className = '' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" fill="none" viewBox="0 0 18 14" className={className}>
    <path stroke="#448020" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 1.5l-11 11-5-5"></path>
  </svg>
);

export default React.memo(CheckIcon);
